export default "__VITE_ASSET__JFm6IBmZ__"